import React from "react";
import Footer from "../components/Footer/Footer";
import Navbar from "../components/Navbar/Navbar";
import SEO from "../components/SEO";

const Insights = () => {
  return (
    <>
      <SEO slug="Insights" />
      <Navbar />
      <div>Insights</div>
      <Footer />
    </>
  );
};

export default Insights;
